module.exports = __webpack_public_path__ + "img/play-2.e0d08932.svg";